<template>
    <div v-if="options_loaded && passed_filter && panel_required" :data-designer-component-id="component_id" class="designeroption">
        <h3>{{ title }}</h3>
        <div class="stylesoption">

            <div v-if="hasCoupler('sides')" :class="['form-group mb-6', 1 === 2 ? 'has-error' : 'has-success']">
                <label :for="'question--' + component_id + '_side_coupler'">Side(s)</label>

                <select :id="'question--' + component_id + '_side_coupler'" class="form-control" v-model="target.sides" v-if="!loading">
                    <option v-for="option in filtered_option_list" :value="option.value">{{ option.label }}</option>
                </select>

                <select :id="'question--' + component_id + '_side_coupler'" disabled class="form-control" v-if="loading">
                    <option>Loading Options...</option>
                </select>

            </div>

            <div v-if="hasCoupler('top')" :class="['form-group', 1 === 2 ? 'has-error' : 'has-success']">
                <label :for="'question--' + component_id + '_top_coupler'">Top</label>

                <select :id="'question--' + component_id + '_top_coupler'" class="form-control" v-model="localTarget.top" v-if="!loading">
                    <option v-for="option in filtered_option_list" :value="option.value">{{ option.label }}</option>
                </select>

                <select :id="'question--' + component_id + '_top_coupler'" disabled class="form-control" v-if="loading">
                    <option>Loading Options...</option>
                </select>

            </div>

        </div>
    </div>
</template>

<script type="text/ecmascript-6">
import Question from "./mixin/Question.vue";

export default {
    mixins: [
        Question,
    ],
    props: {
        title: {
            default(){
                return '';
            }
        },
        component_id: {
            default(){
                return 'couplers';
            }
        },
        frameProfile: {
            required: true
        },
        frameCombination: {
            default(){
                return '';
            }
        }
    },
    computed: {
        passed_filter(){
            return this.variable_ready(this.frameProfile, this.frameCombination);
        },
        url(){
            return '/api/options/' + this.fabricator + '/technical-coupler?profile=' + this.frameProfile + '&frame_combination=' + this.frameCombination;
        },
        cache_key(){
            return '_' + this.frameProfile + '_' + this.frameCombination;
        },
        panel_required(){
            return this.hasCoupler('sides') || this.hasCoupler('top');
        },
    },
    ready(){
        for (var propertyName in this.localTarget) {
            if (Array.isArray(this.localTarget[propertyName])){
                this.localTarget[propertyName] = {};
            }
        }
    },
    methods: {
        hasCoupler(side){
            if (Array.isArray(this.filtered_option_list)) {
                let result = this.filtered_option_list.filter((key) => {
                    return key.positions[side];
                });
                return result.length > 0;
            } else {
                return false;
            }
        },
        select_first() {
            if (!this.options_loaded) return;

            // If no options, reset target to null if it had values
            if (this.filtered_option_list.length === 0) {
                if (this.target.sides !== null || this.target.top !== null) {
                    this.target.sides = null;
                    this.target.top = null;
                }
                return;
            }

            const new_value = this.filtered_option_list[0];

            if (this.hasCoupler('sides')) {
                this.target.sides = new_value.value;
            }

            if (this.hasCoupler('top')) {
                this.target.top = new_value.value;
            }
        }
    },
    watch: {
        'cache_key': function (val, oldVal) {
            this.update_options();
        },
    }
}
</script>
